import { HierarchyContextProps, IHierarchyActionUpdateSingleReplacement } from "./interface";

/**
 * Updates a single replacement in the hierarchy context state.
 *
 * @param action - The action containing the updated single replacement
 * @param state - The current hierarchy context state
 * @returns Updated hierarchy context state with the modified single replacement
 */
export const hcr_updateSingleReplacements = (
  action: IHierarchyActionUpdateSingleReplacement,
  state: HierarchyContextProps,
): HierarchyContextProps => {
  if (!state.hierarchy)
    throw `hierarchyContextReducer: ${action.operation}: Hierarchy not assigned yet`;
  const ix = state.hierarchy.singles.findIndex((s) => s.airid === action.single.airid);
  if (ix > -1) {
    return {
      ...state,
      hierarchy: {
        ...state.hierarchy,
        singles: state.hierarchy.singles.map((s) =>
          s.airid === action.single.airid ? action.single : s,
        ),
      },
    };
  }
  return state;
};
